<template>
  <div>
    <v-slide-group
    v-if="$store.state.homeTrips.length > 0"
    v-model="model"
    class="pa-4 d-none d-sm-flex"
    show-arrows
    prev-icon="mdi-chevron-left-circle"
    next-icon="mdi-chevron-right-circle"
    >
      <v-slide-item
      v-for="trip in trips"
      :key="trip.id"
      >
        <v-card
        class="ma-5"
        height="300"
        width="400"
        @click="goTo(trip.link)"
        >
          <v-img
          :src="trip.image"
          class="white--text align-end"
          height="300px"
          >
            <v-card-title class="featured-trips-title" v-text="trip.title"></v-card-title>
          </v-img>
        </v-card>
      </v-slide-item>
    </v-slide-group>
    <v-card
    class="d-block d-sm-none mx-auto my-5"
    height="300"
    width="250"
    @click="goTo(trip.link)"
    v-for="trip in trips"
    :key="trip.id"
    >
      <v-img
      :src="trip.image"
      class="white--text align-end"
      height="300px"
      >
        <v-card-title class="featured-trips-title" v-text="trip.title"></v-card-title>
      </v-img>
    </v-card>
  </div>
</template>

<script>
import { homeTrips, headersNoAuth } from '../links'

export default {
  data () {
    return {
      trips: [],
      model: null
    }
  },
  methods: {
    goTo (trip) {
      if (trip) {
        this.$store.dispatch('setTrip', trip)
        this.$router.push({ name: 'trip' })
      }
    }
  },
  created () {
    if (this.$store.state.homeTrips.length === 0) {
      this.$http.get(homeTrips, { headers: headersNoAuth() }).then(response => {
        this.trips = response.body.data
      })
    } else this.trips = this.$store.state.homeTrips
  }
}
</script>

<style>
  .featured-trips-title {
    /* background-image: linear-gradient(to top, rgba(50, 0, 255, 0.7), rgb(251 164 5 / 53%)); */
    background-image: linear-gradient(to top, rgba(50, 0, 255, 0.7), rgb(0 0 0 / 53%));
  }
</style>
